import partnerService from "../services/partner";
import whitelabelService from "../services/whitelabel";
import config from "../../config/config";

export default {
  namespaced: true,
  state: {
    isFetchWaiting: true,
    list: [],
    active: null,
    fetchError: null,
  },
  getters: {
    isFetchWaiting: (state) => state.isFetchWaiting,
    list: (state) => state.list,
    active: (state) => state.active,
    fetchError: (state) => state.fetchError,
  },
  mutations: {
    setList(state, accounts) {
      state.isFetchWaiting = false;
      state.list = accounts;
    },
    setFetchError(state, message) {
      state.isFetchWaiting = false;
      state.fetchError = message;
    },
    setActive(state, account) {
      state.active = account;
    },
    clearAll(state) {
      state.isFetchWaiting = true;
      state.list = [];
      state.active = null;
      state.fetchError = null;
    },
  },
  actions: {
    async fetchAccounts({ commit, dispatch }, user) {
      try {
        if (user == null) {
          throw new Error("User is not logged in.");
        }
        let accounts = [];
        console.log(config);
        if (config.whitelabelMode) {
          accounts = await whitelabelService.getAccounts(user.id);
        } else {
          accounts = await partnerService.getPartnerAccounts(user.id);
        }
        if (!accounts || !accounts.length) {
          commit("setFetchError", "No accounts linked.");
          return;
        }
        commit("setList", accounts);
        dispatch("setActive", null);
      } catch (e) {
        console.log(e);
        commit(
          "setFetchError",
          "An error occurred while connecting to the server. Please try again after sometime."
        );
      }
    },
    setActive({ commit, state }, accountId) {
      let accounts = state.list;
      let activeAccount = accounts[0];
      if (accountId) {
        const selectedAccount = accounts.find((x) => x.id === accountId);
        activeAccount = selectedAccount || activeAccount;
      }
      commit("setActive", activeAccount);
      if (window.HelpCrunch) {
        var updates = {
          whitelabelAccountId: activeAccount.oId,
          code: activeAccount.code,
          accountName: activeAccount.accountName,
        };
        window.HelpCrunch("updateUserData", updates);
      }
    },
    clearAccounts({ commit }) {
      commit("clearAll");
    },
    async fetchAccountData({ dispatch }, account) {
      await dispatch("business/fetchBusinesses", account, { root: true });
    },
    clearAccountData({ dispatch }) {
      dispatch("business/clearBusinesses", null, { root: true });
    },
  },
};
